import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  goBackInCardHistory,
  closeCard,
  selectDocumentationCardItem,
  selectDocumentationCardHistoryLength,
  setSelectedCardItem,
} from '../../../../reducers/documentation/documentationCardReducer';
import { DocumentationCardContentViewType } from '../../salesforce-documentation-card/types';

export const useDocumentationCard = () => {
  const dispatch = useDispatch();

  const selectedCardItem = useSelector(selectDocumentationCardItem);
  const historyLength = useSelector(selectDocumentationCardHistoryLength);

  const configurationItem =
    selectedCardItem?.platform === 'salesforce' ? selectedCardItem.item : undefined;

  const handleCloseCard = useCallback(() => {
    dispatch(closeCard());
  }, [dispatch]);

  const onGoBackInHistory = useCallback(() => {
    dispatch(goBackInCardHistory());
  }, [dispatch]);

  const setContentType = useCallback(
    (contentType: DocumentationCardContentViewType) => {
      if (selectedCardItem) {
        dispatch(setSelectedCardItem({ ...selectedCardItem, contentType }));
      }
    },
    [dispatch, selectedCardItem],
  );

  const onGoToMainView = useCallback(() => {
    setContentType(DocumentationCardContentViewType.default);
  }, [setContentType]);

  return {
    handleCloseCard,
    onGoBackInHistory,
    onGoToMainView,
    setContentType,
    historyLength,
    configurationItem,
  };
};
